import { PATHS } from 'src/navigation';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { selectTenantsForSharedUsers, selectAcceptTenantInviteSuccess, selectTenantsForSharedUserLoading } from 'src/redux/tenants/selectors';
import { acceptTenantInvite, loadTenantsForSharedUser } from 'src/redux/tenants/actions';
import { TenantForSharedUserType } from 'src/types/tenant';
import { Loader } from 'src/components';
import AboutContactCompany from 'src/components/AboutContractCompany';
import { DashboardWrapper } from '../wrappers';
import AcceptContractorNotification from '../MyContractorsContainer/AcceptContractorNotification';

function AboutContractorCompanyContainer() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const myTenants = useSelector(selectTenantsForSharedUsers);
  const isAcceptTenantInviteSuccess = useSelector(selectAcceptTenantInviteSuccess);
  const isTenantsLoading = useSelector(selectTenantsForSharedUserLoading);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [tenant, setTenant] = useState<TenantForSharedUserType | null>(null);
  const [isLoadingNeed, setIsNeedLoading] = useState(myTenants.length === 0);

  const { id } = useParams();

  useEffect(() => {
    if (!myTenants.length) {
      dispatch(loadTenantsForSharedUser.init());
    }
    setIsNeedLoading(false);
  }, []);

  useEffect(() => {
    if (isLoadingNeed) {
      return;
    }

    if (myTenants.length === 0) {
      navigate(PATHS.MY_CONTRACTORS_PAGE, { replace: true });
      return;
    }

    if (myTenants.length) {
      const selectedTenant = myTenants.find((tenant) => tenant.id === Number(id));
      if (!selectedTenant) {
        navigate(PATHS.MY_CONTRACTORS_PAGE, { replace: true });
      } else {
        setTenant(selectedTenant);
      }
    }
  }, [myTenants, id, isAcceptTenantInviteSuccess]);

  useEffect(() => {
    if (isAcceptTenantInviteSuccess) {
      setIsSuccessOpen(true);
      dispatch(loadTenantsForSharedUser.init());
      dispatch(acceptTenantInvite.reset());
    }
  }, [isAcceptTenantInviteSuccess]);

  const onAcceptHandler = (id: number) => {
    dispatch(acceptTenantInvite.init({ id }));
  };

  const onCloseAcceptSuccess = () => {
    setIsSuccessOpen(false);
  };

  return (
    <DashboardWrapper breadcrumbs={[[`${tenant?.title}`]]}>
      {isTenantsLoading ? <Loader /> : tenant && <AboutContactCompany onAcceptHandler={onAcceptHandler} tenant={tenant} />}
      <AcceptContractorNotification isSuccessOpen={isSuccessOpen} onCloseAcceptSuccess={onCloseAcceptSuccess} />
    </DashboardWrapper>
  );
}

export default AboutContractorCompanyContainer;
